import config from '@/config/global'
import geoJsonWorldCoastline from '@/config/worldLand.json'
import { latLng, polygon } from 'leaflet'
import { point } from '@turf/helpers'
import { getCoord } from '@turf/invariant'
import booleanPointInPolygon from '@turf/boolean-point-in-polygon'

/**
 * Generate a random coordinate
 *
 * @returns {Object} Feature <Point> (GeoJSON), using Turf.js
 */
function randomPoint () {
  return point([
    Math.random() *
    (config.coordinateBoundaries.maxLng - config.coordinateBoundaries.minLng + 1) +
    config.coordinateBoundaries.minLng,
    Math.random() *
    (config.coordinateBoundaries.maxLat - config.coordinateBoundaries.minLat + 1) +
    config.coordinateBoundaries.minLat]
  )
}

/**
 * Generate a random coordinate on land. Accuracy around coastline is
 * restricted by provided MultiPolygon object.
 *
 * @returns {Object} Feature <Point> (GeoJSON), using Turf.js
 */
function randomPointOnLand () {
  var point
  do {
    point = randomPoint()
    if (process.env.NODE_ENV === 'development') {
      console.log('Testing GeoJSON point for being on land: ', point)
    }
  } while (!booleanPointInPolygon(point, geoJsonWorldCoastline))

  return point
}

/**
 * Swap coordinates of a single point. Background to this is that GeoJSON/Turf.js
 * use [longitude, latidtude] order, whereas applications (including leaflet)
 * use [latitude, longitude]
 *
 * @param {Array} coordinates
 */
function swapPointCoordinates (arr) {
  return [arr[1], arr[0]]
}

export default {
  /**
   * Generates a random coordinate on land
   *
   * @returns {Object} Leaflet LatLng
   */
  randomCenter () {
    return latLng(swapPointCoordinates(getCoord(randomPointOnLand())))
  },

  /**
   * Converts Leaflet LatLngBounds object to a GeoJSON polygon
   *
   * @param {Object} Leaflet LatLngBounds
   */
  boundsToGeoJsonPolygon (bounds) {
    const north = bounds.getNorth()
    const east = bounds.getEast()
    const south = bounds.getSouth()
    const west = bounds.getWest()

    return polygon([
      [north, east],
      [north, west],
      [south, west],
      [south, east]
    ]).toGeoJSON()
  },

  /**
   * Converts Leaflet LatLngBounds object to an array of NE-SW-coordinates
   * expected by VueLeaflet LRectangle component
   *
   * @param {Object} Leaflet LatLngBounds
   */
  boundsToVueLeafletArray (bounds) {
    const north = bounds.getNorth()
    const east = bounds.getEast()
    const south = bounds.getSouth()
    const west = bounds.getWest()

    return [
      [north, east],
      [south, west]
    ]
  }
}
